import React from 'react'
import { Link } from 'react-router-dom'
import { alpha, Box, Button, Chip, Container, Fade, Grid, Typography } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import { founderPhilosophy } from '@components/philosophy.jsx'

const AboutPage = () => {
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    setIsVisible(true)
  }, [])

  return (<Box sx={{
    bgcolor: '#FAFAF9', minHeight: '100vh', overflow: 'hidden', position: 'relative'
  }}>

    <Box sx={{
      position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: `
          radial-gradient(circle at 20% 80%, rgba(184, 153, 104, 0.03) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(184, 153, 104, 0.02) 0%, transparent 50%),
          linear-gradient(135deg, #FAFAF9 0%, #F5F3F0 100%)
        `, zIndex: 0, '&::before': {
        content:    '""',
        position:   'absolute',
        top:        0,
        right:      0,
        width:      '40%',
        height:     '100%',
        background: 'linear-gradient(135deg, rgba(184, 153, 104, 0.05) 0%, rgba(184, 153, 104, 0.06) 100%)',
        clipPath:   'polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)',
        zIndex:     0
      }
    }}/>


    <Container maxWidth="lg" sx={{
      pt: { xs: 12, md: 16 }, pb: { xs: 8, md: 12 }, position: 'relative', zIndex: 1
    }}>
      <Fade in={isVisible} timeout={1000}>
        <Box sx={{ textAlign: 'center', maxWidth: '800px', mx: 'auto' }}>
          <Typography variant="h6" sx={{
            fontWeight:    300,
            color:         '#1A1A1A',
            fontSize:      { xs: '2.3rem', md: '3.3rem' },
            fontFamily:    '"Inter", sans-serif',
            letterSpacing: '0.1em'
          }}>
            IMSEEN INTERIORS
          </Typography>

          <Box sx={{
            position: 'relative', mb: 6, '&::before': {
              content:   '""',
              position:  'absolute',
              top:       0,
              left:      '50%',
              transform: 'translateX(-50%)',
              width:     '60px',
              height:    '1px',
              bgcolor:   '#B89968'
            }
          }}>
            <Typography
             variant="h6"
             sx={{
               fontWeight: 300,
               lineHeight: 1.6,
               color:      '#666',
               fontSize:   { xs: '1.1rem', md: '1.25rem' },
               fontStyle:  'italic',
               pt:         4,
               maxWidth:   '600px',
               mx:         'auto'
             }}
            >
              Where spaces become stories, and design meets soulful intention.
            </Typography>
          </Box>

          <Typography
           sx={{
             fontSize:   { xs: '1rem', md: '1.125rem' },
             fontWeight: 300,
             lineHeight: 1.8,
             color:      '#666',
             maxWidth:   '700px',
             mx:         'auto'
           }}
          >
            We believe design should resonate beyond aesthetics—creating environments that
            feel as beautiful as they look. Each project is a collaborative journey,
            crafting spaces that reflect your essence while elevating daily experience.
          </Typography>
        </Box>
      </Fade>
    </Container>


    <Container maxWidth="lg" sx={{
      py: { xs: 8, md: 12 }, position: 'relative', zIndex: 1
    }}>
      <Fade in={isVisible} timeout={1200}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
           variant="h2"
           sx={{
             fontSize:   { xs: '2rem', md: '3rem' },
             fontWeight: 300,
             mb:         2,
             color:      '#1a1a1a',
             fontFamily: '"Cormorant Garamond", serif'
           }}
          >
            Our Philosophy
          </Typography>
          <Typography
           sx={{
             color: '#666', maxWidth: 400, mx: 'auto', lineHeight: 1.6, fontSize: '1rem', fontWeight: 300
           }}
          >
            Where creativity meets craftsmanship in perfect harmony
          </Typography>
        </Box>
      </Fade>

      <Grid container spacing={4} justifyContent="center">
        {founderPhilosophy.map((service, index) => (<Grid item xs={12} md={6} lg={4} key={index}>
          <Fade in={isVisible} timeout={800 + index * 200}>
            <Box
             sx={{
               height:            '100%',
               p:                 4,
               textAlign:         'center',
               position:          'relative',
               boxShadow:         '0 8px 32px rgba(0, 0, 0, 0.1)',
               textShadow:        '0 1px 2px rgba(255, 255, 255, 0.4)',
               borderRadius:      '24px',
               '&::before':       {
                 content:    '""',
                 position:   'absolute',
                 top:        0,
                 left:       0,
                 right:      0,
                 height:     '1px',
                 background: 'linear-gradient(90deg, transparent, #574b3a, transparent)',
                 opacity:    0,
                 transition: 'opacity 0.3s ease'
               },
               '&:hover::before': {
                 opacity: 1
               }
             }}
            >


              <Typography
               variant="h5"
               sx={{
                 fontSize:   '1.25rem',
                 fontWeight: 400,
                 color:      '#1a1a1a',
                 mb:         2,
                 fontFamily: '"Cormorant Garamond", serif'
               }}
              >
                {service.title}
              </Typography>

              <Typography
               sx={{
                 fontSize: '0.9rem', color: '#666', lineHeight: 1.6, fontWeight: 300
               }}
              >
                {service.description}
              </Typography>
            </Box>
          </Fade>
        </Grid>))}
      </Grid>
    </Container>


    <Box sx={{
      position: 'relative', py: { xs: 10, md: 15 }, '&::before': {
        content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: `
            linear-gradient(135deg, rgba(184, 153, 104, 0.08) 0%, transparent 50%),
            linear-gradient(45deg, transparent 30%, rgba(184, 153, 104, 0.05) 100%)
          `, zIndex: 0
      }
    }}>
      <Container sx={{
        py: { xs: 8, md: 12 }, position: 'relative', zIndex: 1
      }} maxWidth="md">
        <Fade in={isVisible} timeout={1400}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
             variant="h3"
             sx={{
               fontSize:   { xs: '1.5rem', md: '2rem' },
               fontWeight: 300,
               mb:         4,
               color:      '#1a1a1a',
               fontFamily: '"Cormorant Garamond", serif',
               fontStyle:  'italic',
               lineHeight: 1.6
             }}
            >
              "No templates. No copy-paste design. Just artistry with purpose,
              designed around your lifestyle, energy, and vision."
            </Typography>

            <Box sx={{
              display: 'flex', justifyContent: 'center', gap: 4, mt: 6, flexWrap: 'wrap'
            }}>
              {[
                '8+ Years Excellence',
                'Dual Design & Engineering Expertise',
                'Luxury Properties',
                'Full-Service Studio',
                'Personalized Process'].map((item, index) => (<Chip
               key={index}
               label={item}
               variant="outlined"
               sx={{
                 fontSize:     '0.9rem',
                 color:        '#515151',
                 fontWeight:   300,
                 borderColor:  '#937e5c',
                 borderRadius: '16px',
                 boxShadow:    '0 8px 32px rgba(0, 0, 0, 0.1)',
                 textShadow:   '0 1px 2px rgba(255, 255, 255, 0.5)',
                 '&:hover':    {
                   backgroundColor: 'rgba(184, 153, 104, 0.08)'
                 }
               }}
              />))}
            </Box>
          </Box>
        </Fade>
      </Container>
    </Box>


    <Container maxWidth="lg" sx={{
      py: { xs: 10, md: 15 }, position: 'relative', zIndex: 1
    }}>
      <Fade in={isVisible} timeout={1600}>
        <Box sx={{
          background:     'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(250,248,246,0.95) 100%)',
          backdropFilter: 'blur(20px)',
          borderRadius:   '32px',
          overflow:       'hidden',
          border:         '1px solid rgba(184, 153, 104, 0.1)',
          boxShadow:      '0 20px 60px rgba(0, 0, 0, 0.08)',
          position:       'relative'
        }}>
          <Box sx={{
            position:      'absolute',
            top:           0,
            right:         0,
            width:         '50%',
            height:        '100%',
            background:    'linear-gradient(135deg, rgba(184, 153, 104, 0.03) 0%, transparent 100%)',
            pointerEvents: 'none'
          }}/>

          <Grid container spacing={0} alignItems="center">
            <Grid item xs={12} md={5} sx={{ p: { xs: 4, md: 6 }, }}>
              <Box sx={{
                width:    { xs: '300px', md: '420px' },
                height:   { xs: '300px', md: '420px' },
                position: 'relative',

                borderRadius:   '50%',
                overflow:       'hidden',
                display:        'flex',
                justifyContent: 'center',
                alignItems:     'center',

                '&::after': {
                  content:       '""',
                  position:      'absolute',
                  top:           '0px',
                  left:          '0px',
                  right:         '0px',
                  bottom:        '0px',
                  borderRadius:  '50%',
                  border:        '1px solid #B8860B',
                  animation:     'rotateRing 3s linear infinite',
                  pointerEvents: 'none',
                  zIndex:        2,
                },

                '@keyframes rotateRing': {
                  '0%':      {
                    transform: 'rotate(0deg)',
                  }, '100%': {
                    transform: 'rotate(360deg)',
                  }
                }
              }}>
                <Box sx={{
                  width:        { xs: '280px', md: '400px' },
                  height:       { xs: '280px', md: '400px' },
                  position:     'relative',
                  borderRadius: '50%',
                  overflow:     'hidden',

                  '&::before': {
                    content:       '""',
                    position:      'absolute',
                    top:           '-20px',
                    left:          '-10px',
                    right:         '-10px',
                    bottom:        '-10px',
                    borderRadius:  '50%',
                    pointerEvents: 'none',
                    zIndex:        1,
                  },
                }}>
                  <Box
                   component="img"
                   src="/images/founderPreview.png"
                   alt="Juleen Imseeh - Founder and Creative Director of Imseen Interiors"
                   loading="lazy"
                   sx={{
                     width:          '100%',
                     height:         '100%',
                     objectFit:      'cover',
                     objectPosition: 'center -10%',
                     transform:      'scale(1.3)',
                     filter:         `
                    grayscale(0) 
                    brightness(1.05) 
                    contrast(1.1) 
                    sepia(0.1) 
                    saturate(1.0)
                `,
                     transition:     'all 0.5s ease',
                     position:       'relative',
                     zIndex:         0,
                     '&:hover':      {
                       transform: 'scale(1.35)', filter: `
                        grayscale(0) 
                        brightness(1.05) 
                        contrast(1.1) 
                        sepia(0.04) 
                        saturate(1.1)
                    `,
                     }
                   }}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <Box sx={{
                p: { xs: 4, md: 6, lg: 8 }, position: 'relative', zIndex: 1
              }}>
                <Typography
                 variant="overline"
                 sx={{
                   color:         '#B89968',
                   letterSpacing: '0.15em',
                   fontSize:      '1rem',
                   fontWeight:    500,
                   mb:            2,
                   display:       'block',
                   textAlign:     'center'
                 }}
                >
                  MEET THE FOUNDER
                </Typography>

                <Typography
                 variant="h2"
                 sx={{
                   fontSize:   { xs: '2rem', md: '2.75rem' },
                   fontWeight: 300,
                   mb:         1,
                   color:      '#1a1a1a',
                   fontFamily: '"Cormorant Garamond", serif',
                   lineHeight: 1.2,
                   textAlign:  'center'
                 }}
                >
                  Juleen Imseeh
                </Typography>

                <Typography
                 sx={{
                   fontSize:      '0.875rem',
                   color:         '#574b3a',
                   mb:            4,
                   letterSpacing: '0.1em',
                   textTransform: 'uppercase',
                   fontWeight:    400
                 }}
                >

                </Typography>

                <Typography
                 sx={{
                   fontSize: '1.0625rem', lineHeight: 1.8, color: '#666', mb: 3, fontWeight: 300
                 }}
                >
                  With over eight years perfecting the art of interior design, home staging, and
                  digital innovation, Juleen brings a distinctive harmony of creativity and
                  intention to every space she touches.
                </Typography>
                <Typography
                 sx={{
                   fontSize: '1.0625rem', lineHeight: 1.8, color: '#666', mb: 3, fontWeight: 300
                 }}
                >


                  Guided by an intuitive understanding of beauty, balance, and lifestyle, Juleen
                  transforms interiors into experiences that are timeless, purposeful, and deeply
                  personal.
                </Typography>
                <Box sx={{
                  borderRadius: '16px', backgroundColor: 'rgba(198,145,12,0.03)', p: 3, my: 4
                }}>
                  <Typography
                   sx={{
                     fontSize:   '1rem',
                     lineHeight: 1.75,
                     color:      '#a68042',
                     fontStyle:  'italic',
                     fontWeight: 300,
                     textAlign:  'center',
                     m:          0
                   }}
                  >
                    "Every space tells a story. My work is about listening closely enough to
                    bring it to life.”
                  </Typography>
                </Box>
                <Box sx={{
                  display:    'flex',
                  gap:        2,
                  mb:         5,
                  flexWrap:   'wrap',
                  ml:         10,
                  alignItems: 'center',
                  textAlign:  'center',
                  alignSelf:  'center',
                }}>

                </Box>

                <Button
                 component={Link}
                 to="/about/founder"
                 endIcon={<ArrowForward/>}
                 sx={{
                   borderColor:  '#675944',
                   background:   '#A8815B',
                   color:        '#fbfafa',
                   borderRadius: '25px',
                   fontSize:     '0.9rem',
                   fontWeight:   500,
                   px:           0,
                   ml:           20,
                   padding:      2,

                   textTransform:        'none',
                   letterSpacing:        '0.5px',
                   '&:hover':            {
                     backgroundColor: alpha('#A8815B', 0.7), '& .MuiSvgIcon-root': {
                       transform: 'translateX(4px)'
                     }
                   },
                   '& .MuiSvgIcon-root': {
                     fontSize: '1.25rem', transition: 'transform 0.3s ease'
                   }
                 }}
                >
                  Discover Her Story
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Container>


    <Container maxWidth="md" sx={{
      py: { xs: 8, md: 12 }, position: 'relative', zIndex: 1
    }}>
      <Fade in={isVisible} timeout={1600}>
        <Box sx={{
          textAlign: 'center', p: { xs: 4, md: 6 }
        }}>
          <Typography
           variant="h3"
           sx={{
             fontSize:   { xs: '1.75rem', md: '2.5rem' },
             fontWeight: 300,
             mb:         3,
             color:      '#1a1a1a',
             fontFamily: '"Cormorant Garamond", serif'
           }}
          >
            Begin Your Transformation
          </Typography>
          <Typography
           sx={{
             fontSize: '1rem', lineHeight: 1.6, color: '#666', mb: 5, maxWidth: '500px', mx: 'auto', fontWeight: 300
           }}
          >
            Let's collaborate to create spaces that resonate with your soul and elevate your everyday.
          </Typography>
          <Box
           component={Link}
           to="/contact"
           sx={{
             display:        'inline-flex',
             alignItems:     'center',
             px:             4,
             py:             1.5,
             color:          '#574b3a',
             textDecoration: 'none',
             fontSize:       '0.9rem',
             fontWeight:     400,
             letterSpacing:  '0.5px',
             border:         '1px solid #574b3a',
             transition:     'all 0.3s ease',
             '&:hover':      {
               bgcolor: 'rgba(184, 153, 104, 0.05)', letterSpacing: '1px'
             }
           }}
          >
            Start Your Journey
          </Box>
        </Box>
      </Fade>
    </Container>
  </Box>)
}

export default AboutPage